import { render, staticRenderFns } from "./build12.vue?vue&type=template&id=4e968698&scoped=true&"
import script from "./build12.vue?vue&type=script&lang=js&"
export * from "./build12.vue?vue&type=script&lang=js&"
import style0 from "./build12.vue?vue&type=style&index=0&id=4e968698&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4e968698",
  null
  
)

export default component.exports